module.exports = __webpack_public_path__ + "static/storm-giants-5ea00dd6b3207c3894e28e255fbc7afe.jpg";